import { lightTheme } from '@capture/capture-components'
import { overrideAccountFromSearchParams } from '@capture/client/API/login'
import { TestFlagService } from '@capture/client/API/services/TestFlagService'
import '@capture/client/assets/globalStyle.scss'
import { cacheLocaleStrings } from '@capture/client/assets/localization/util'
import { SuggestModernBrowser } from '@capture/client/components/Info/SuggestModernBrowser'
import { getCurrentLocale } from '@capture/client/config/constants'
import { isModernBrowser } from '@capture/client/utilities/device'
import { setDocumentTitle } from '@capture/client/utilities/documentTitle'
import { consoleLog } from '@capture/client/utilities/logging'
import { APIQueryProvider } from '@capture/client/query/APIQueryProvider'
import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { ThemeProvider } from 'styled-components'

import { MainRouter } from './routing/MainRouter'
import { getStore } from './store.client'

setDocumentTitle() // Setting the default-title to have the localized version set by default

const locale = getCurrentLocale()
cacheLocaleStrings(locale)

const container = document.getElementById('app')
const root = createRoot(container!)

if (!isModernBrowser()) {
    root.render(
        <React.StrictMode>
            <SuggestModernBrowser />
        </React.StrictMode>,
    )
}

// convert eventual params to test flags
TestFlagService.paramsToFlags()
overrideAccountFromSearchParams()

consoleLog(`Launching CaptureWeb version: ${import.meta.env.VITE_VERSION}`)
root.render(
    <React.StrictMode>
        <APIQueryProvider>
            <Provider store={getStore()}>
                <ThemeProvider theme={lightTheme}>
                    <MainRouter />
                </ThemeProvider>
            </Provider>
        </APIQueryProvider>
    </React.StrictMode>,
)
